import 'regenerator-runtime/runtime';
import { call, put, takeLatest, all } from 'redux-saga/effects';
import { AppSettings } from '../constants';
import {
  createPunchList,
  searchPunchList,
  getPunchListDetail,
  createPunchListItem,
  getPunchListItemDetail,
  updatePunchItem,
  sendPunchItem,
  sendMultiplePunchItem,
  setupPunchListAWS,
  uploadPunchListAttachmentToS3,
  uploadPunchListAttachmentToServer,
  getSubcontractorPunchListDetail,
  updatePunchListManagedBy,
  exportPunchListList,
  searchSubcontractorPunchList
} from './api';
import * as PunchListActionType from './constants';
import * as WorkOrderAction from '../Work-Orders/constants';
import * as NotifyActionType from '../Notification/constants';
import * as LotActionType from '../Lots/constants';

export function* searchPunchListAsync(action) {
  const result = yield call(searchPunchList, action.params);
  const statusCode = result.statusCode;
  console.log('saga.js', result)
  if (statusCode === 200) {
    yield put({
      type: PunchListActionType.SEARCH_PUNCH_LIST_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* createPunchListAsync(action) {
console.log('createPunchList saga', action.params)
  const result = yield call(createPunchList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: NotifyActionType.NOTIFY_SUCCESS,
        data: 'Punch list created.'
      })
    ];
    if (action.callback) {
      action.callback(result.data.refNo);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getPunchListDetailAsync(action) {
  const { data, statusCode } = yield call(getPunchListDetail, action.params);
  if (statusCode === 200) {
    yield [
      put({
        type: PunchListActionType.GET_PUNCH_LIST_DETAIL_SUCCESS,
        data: data
      })
    ];
    if (action.callback) {
      action.callback(data, true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
    if (action.callback) {
      action.callback(data, false);
    }
  }
}

export function* createPunchListItemAsync(action) {
  const { data, statusCode } = yield call(createPunchListItem, action.params);
  if (statusCode === 200) {
    yield [
      put({
        type: NotifyActionType.NOTIFY_SUCCESS,
        data: 'Punch item created.'
      })
    ];
    if (action.callback) {
      action.callback(data.refNo, true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
    if (action.callback) {
      action.callback(data, false);
    }
  }
}

export function* getPunchListItemDetailAsync(action) {
  const { data, statusCode } = yield call(
    getPunchListItemDetail,
    action.params
  );
  if (statusCode === 200) {
    if (AppSettings.clientTypeValue === 'Subcontractor') {
      yield [
        put({
          type: PunchListActionType.GET_PUNCH_LIST_ITEM_DETAIL_SUCCESS,
          data: data
        }),
        put({ type: WorkOrderAction.GET_WORK_ORDER_DETAIL_SUCCESS, data: data }),
        put({
          type: LotActionType.GET_SUBCONTRACTOR_LOT_ID_ASYNC,
          params: {
            endpoint: data.builderProfile.lotDetailEndpoint,
            headers: {
              key: data.builderProfile.headerKey,
              value: data.builderProfile.securityToken
            }
          }
        })
      ];
      if (action.callback) {
        action.callback(data);
      }
    }
    else {
      yield [
        put({
          type: PunchListActionType.GET_PUNCH_LIST_ITEM_DETAIL_SUCCESS,
          data: data
        }),
        put({ type: WorkOrderAction.GET_WORK_ORDER_DETAIL_SUCCESS, data: data }),
        put({
          type: LotActionType.GET_LOT_BY_ID_ASYNC,
          params: data.requestDetail.lot.id
        })
      ];
    }

    if (action.callback) {
      action.callback(data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
  }
}

export function* updatePunchItemAsync(action) {
  const { data, statusCode } = yield call(updatePunchItem, action.params);
  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
      put({ type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS, data: data })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
  }
}

export function* sendPunchItemAsync(action) {
  const { data, statusCode } = yield call(sendPunchItem, action.params);
  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Sent' }),
      put({ type: PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS, data: data })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
  }
}

export function* sendMultiplePunchItemAsync(action) {
  const { data, statusCode } = yield call(sendMultiplePunchItem, action.params);
  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Sent' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data[0] });
  }
}

export function* setupPunchListAWSAsync(action) {
  const result = yield call(setupPunchListAWS, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: PunchListActionType.SETUP_PUNCH_LIST_AWS_SUCCESS,
      data: result.data
    });
    setTimeout(() => {
      if (action.callback) {
        action.callback();
      }
    }, 500);
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* uploadPunchListAttachmentToS3Async(action) {
  const paramsUpload = {
    refNo: action.params.refNo,
    file: action.params.file,
    config: action.params.config
  };
  yield call(uploadPunchListAttachmentToS3, paramsUpload, action.callback);
}

export function* uploadPunchListAttachmentToServerAsync(action) {
  const result = yield call(uploadPunchListAttachmentToServer, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    console.log('Punch list attachment status 200');
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updatePunchListManagedByAsync(action) {
  const result = yield call(updatePunchListManagedBy, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: PunchListActionType.GET_PUNCH_LIST_DETAIL_ASYNC,
        params: { refNo: action.params.refNo },
        callback: action.callback
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

//SUBCONTRACTOR
export function* getSubcontractorPunchListDetailAsync(action) {
  const { data, statusCode } = yield call(
    getSubcontractorPunchListDetail,
    action.params
  );
  if (statusCode === 200) {
    yield [
      put({
        type: PunchListActionType.GET_PUNCH_LIST_DETAIL_SUCCESS,
        data: data
      })
    ];
    if (action.callback) {
      action.callback(data, true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: data.error });
  }
}

export function* exportPunchListListAsync(action) {
  const result = yield call(exportPunchListList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    //get file name
    let filename = 'PunchLists.xlsx';
    let disposition = result.headers['content-disposition'];
    if (disposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    let blob = new Blob([result.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // for IE browser
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // for Non-IE (chrome, firefox etc.)
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* searchSubcontractorPunchListAsync(action) {
  const result = yield call(searchSubcontractorPunchList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: PunchListActionType.SEARCH_SUBCONTRACTOR_PUNCH_LIST_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export default function* WatchPunchList() {
  yield all([
    takeLatest(
      PunchListActionType.SEARCH_PUNCH_LIST_ASYNC,
      searchPunchListAsync
    ),
    takeLatest(
      PunchListActionType.CREATE_PUNCH_LIST_ASYNC,
      createPunchListAsync
    ),
    takeLatest(
      PunchListActionType.GET_PUNCH_LIST_DETAIL_ASYNC,
      getPunchListDetailAsync
    ),
    takeLatest(
      PunchListActionType.CREATE_PUNCH_LIST_ITEM_ASYNC,
      createPunchListItemAsync
    ),
    takeLatest(
      PunchListActionType.GET_PUNCH_LIST_ITEM_DETAIL_ASYNC,
      getPunchListItemDetailAsync
    ),
    takeLatest(
      PunchListActionType.UPDATE_PUNCH_ITEM_ASYNC,
      updatePunchItemAsync
    ),
    takeLatest(PunchListActionType.SEND_PUNCH_ITEM_ASYNC, sendPunchItemAsync),
    takeLatest(
      PunchListActionType.SEND_MULTIPLE_PUNCH_ITEM_ASYNC,
      sendMultiplePunchItemAsync
    ),
    takeLatest(
      PunchListActionType.SETUP_PUNCH_LIST_AWS_ASYNC,
      setupPunchListAWSAsync
    ),
    takeLatest(
      PunchListActionType.UPLOAD_PUNCH_LIST_ATTACHMENT_TO_S3_ASYNC,
      uploadPunchListAttachmentToS3Async
    ),
    takeLatest(
      PunchListActionType.UPLOAD_PUNCH_LIST_ATTACHMENT_TO_SERVER_ASYNC,
      uploadPunchListAttachmentToServerAsync
    ),
    takeLatest(
      PunchListActionType.GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_ASYNC,
      getSubcontractorPunchListDetailAsync
    ),
    takeLatest(
      PunchListActionType.UPDATE_PUNCH_LIST_MANAGED_BY_ASYNC,
      updatePunchListManagedByAsync
    ),
    takeLatest(
      PunchListActionType.EXPORT_PUNCH_LIST_LIST,
      exportPunchListListAsync
    ),
    takeLatest(
      PunchListActionType.SEARCH_SUBCONTRACTOR_PUNCH_LIST_ASYNC,
      searchSubcontractorPunchListAsync
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/Punch-List/saga.js